import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "carsi",
  name: "Çarşı",
  tagline: "Komşu taşları kaydır, üçlüleri patlat, özel taşları birleştir.",
  inspiredBy: "Royal Match / Candy Crush (match-3, hedefli seviyeler)",
  secondLayer: "Özel taş kombinasyonları (roket+bomba, ışık+uçurtma…) ve sandık, çini, zincir engelleri.",
  accent: "#ff4d6d",
  status: "lab",
};
